import { StackClientApp } from "@stackframe/react";
import { useNavigate } from "react-router-dom";

export const stackClientApp = new StackClientApp({
  // You should store these in environment variables based on your project setup
  projectId: "4dad330e-7926-403a-a0dc-8ea5333e1426",
  publishableClientKey: "pck_ceeqv4kexc7f3apsefp84bntpka8jhe0cqavz36pg7keg",
  tokenStore: "cookie",
  redirectMethod: {
    useNavigate,
  }
});
